import axios from '../axios'

// 受講登録の削除（admin のみ）
const deleteEnrollmentApi = async (enrollmentId) => {
  return await axios.delete(`api/lms/enrollments/${enrollmentId}`)
}

export default deleteEnrollmentApi
